// ═══════════════════════════════════════════════════════════════
// communityAnalytics.ts — FACADE
// All data re-exported from adminAnalyticsUnified.ts (single source of truth)
// ═══════════════════════════════════════════════════════════════

import {
  type AnalyticsKpi,
  type TopItem as UnifiedTopItem,
  communityKpis as unifiedCommunityKpis,
  unifiedTops,
  timePeriodLabels as unifiedTimePeriodLabels,
  type TimePeriod as UnifiedTimePeriod,
  getCommunityAnalytics as unifiedGetCommunityAnalytics,
} from './adminAnalyticsUnified';

// ── Types (backward compatible) ──
export type CommunityKpi = AnalyticsKpi;
export type TopCommunityItem = UnifiedTopItem;
export interface CommunityTopsData {
  miembros: UnifiedTopItem[];
  programas: UnifiedTopItem[];
  horarios: UnifiedTopItem[];
}
export type CommunityTimePeriod = UnifiedTimePeriod;

// ── Constants ──
export const communityTimePeriodLabels = unifiedTimePeriodLabels;
export const communityKpis: CommunityKpi[] = unifiedCommunityKpis;
export const communityTops: CommunityTopsData = {
  miembros: unifiedTops.miembros,
  programas: unifiedTops.comunidadProgramas,
  horarios: unifiedTops.horarios,
};

// ── Helpers ──
export const getCommunityAnalytics = unifiedGetCommunityAnalytics;